<template>
  <div>
    
    <b-modal
      ref="mdlImpegnativa"
      :title="'Impegnativa'"
      size="xl"
      style="height: 100%; max-height: 100%; width: 80%; max-width: 80%"
      centered
      scrollable
      footer-tag="footer"
      no-close-on-backdrop
      :no-close-on-esc="noCloseOnEsc"
      :hide-header-close="hideHeaderClose"
    >
      <b-row
        class="sa-padding-left text-left"
        style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem"
      >
        <!-- <b-col cols="12" xs="12" sm="12" md="12" lg="10" xl="10">
        <label class="sa-label-data">
          <b-form-group label="Accettazione" v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              v-model="selectedCheckBoxs"
              :options="optionsCheckBoxGroup"
              :aria-describedby="ariaDescribedby"
              @change="onChangeTypesAccettazione"
              switches
              :disabled="!isEdit "
            ></b-form-checkbox-group>
          </b-form-group>
        </label>
      </b-col> -->
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Tipologia Ricetta</label>
          <b-form-select
            v-model="localData.tipologiaRicetta"
            :options="tipologiaRicettaOptions"
            value-field="value"
            text-field="text"
            :disabled="!isEdit"
            @change="onChangeTipologia"
          >
            <template #first>
              <b-form-select-option disabled :value="null"
                >Seleziona</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <label class="sa-label-data">Numero Impegnativa (NRE)</label>

           <b-row>
            <b-col cols="4" xs="12" sm="12" md="12" lg="4" xl="4">
              <b-form-input
                :disabled="!isEdit"
                v-model="localData.codiceBar1"
                class="text-upper"
                maxlength="7"
              ></b-form-input
            ></b-col>
            <b-col cols="8" xs="12" sm="12" md="12" lg="8" xl="8">
              <b-form-input
                :disabled="!isEdit"
                v-model="localData.codiceBar2"
                class="text-upper"
                maxlength="10"
              ></b-form-input
            ></b-col>
          </b-row>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <label class="sa-label-data">Codice Fiscale Assisito</label>
          <b-form-input
            :disabled="true"
            class="text-upper"
            v-model="localData.codiceFiscaleAssistito"
          ></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Data Prescrizione</label>
          <date-picker
            format="DD/MM/YYYY"
            value-type="timestamp"
            v-model="localData.dataPrescrizione"
            :disabled="
              !isEdit
            "
            type="date"
          ></date-picker>
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Data inizio erogazione</label>
          <date-picker
            format="DD/MM/YYYY"
            value-type="timestamp"
            v-model="localData.dataInizioErogazione"
            :disabled="
              !isEdit
            "
            type="date"
          ></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Data fine erogazione</label>
          <date-picker
            format="DD/MM/YYYY"
            value-type="timestamp"
            v-model="localData.dataFineErogazione"
            :disabled="
              !isEdit 
            "
            type="date"
          ></date-picker>
        </b-col>
         <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
                <div role="regioneResidenzainput">                 
              <label class="sa-label-data">Regione</label>
              <b-form-select
                id="inline-form-custom-select-pref"
                class="mb-2 mr-sm-2 mb-sm-0"
                :value="null"
                :disabled="!isEdit"
                v-model="localData.presRegione"
                value-field="codiceIstat"
                :state="getStateValidationField('presRegione')"
                text-field="regione"
                :options="regioniOptions"
                required
              >
                <template #first>
                  <b-form-select-option :value="null" disabled
                    >- Seleziona -</b-form-select-option
                  >
                </template>
              </b-form-select>
               <b-form-invalid-feedback id="input-live-feedback">
                {{ getMsg("presRegione") }}
            </b-form-invalid-feedback>
          </div>
            </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Matricola</label>
          <b-input-group class="mt-3">
                  <b-form-input
            :disabled="
              !isEdit
            "
            class="text-upper"
            v-model="localData.matricola"
          ></b-form-input>
            <b-input-group-append>
              <b-button
                variant="outline-info"
                @click="$refs.mdlMedici.show()"
                :disabled="
                  !isEdit
                "
                ><font-awesome-icon icon="search"
              /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Cognome</label>
          <b-form-input
            :disabled="
              !isEdit
            "
            class="text-upper"
            v-model="localData.presCognome"
          ></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Nome</label>
          <b-form-input
            :disabled="
              !isEdit 
            "
            class="text-upper"
            v-model="localData.presNome"
          ></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Pres. Codice Fiscale</label>
          <b-form-input
            :disabled="
              !isEdit 
            "
            class="text-upper"
            v-model="localData.presCodiceFiscale"
          ></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Pres. Tipo. </label>
          <b-form-select
            id="inline-form-custom-select-pref"
            v-model="localData.codiceSpecializzazioneMedico"
            class="mb-2 mr-sm-2 mb-sm-0"
            :disabled="
              !isEdit 
            "
            :options="presTipologiaOptions"
            :value="null"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >- Seleziona -</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <label class="sa-label-data">Diagnosi codificata (DA COMPLETARE)</label>
          <b-input-group class="mt-3">
            <b-form-input
              v-model="localData.descrizioneDiagnosi"
              :disabled="
                !isEdit 
              "
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!isEdit" variant="outline-info"
                ><font-awesome-icon icon="search"
              /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Non Esente</label>
          <b-form-checkbox
            switch
            v-model="localData.nonEsente"
            :disabled="
              !isEdit
            "
          ></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Reddito</label>
          <b-form-checkbox
            switch
            v-model="localData.esenteReddito"
            :disabled="
              !isEdit
            "
          ></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Codice Esenzione</label>
          <b-input-group class="mt-3">
            <b-form-input
              v-model="localData.codiceEsenzione"
              :disabled="
                !isEdit 
              "
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="
                  !isEdit
                "
                variant="outline-info"
                ><font-awesome-icon icon="search"
              /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Priorità</label>
          <b-form-select
            id="inline-form-custom-select-pref"
            v-model="localData.classePriorita"
            class="mb-2 mr-sm-2 mb-sm-0"
            :disabled="
              !isEdit
            "
            :options="prioritaOptions"
            :value="null"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >- Seleziona -</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <b-button
            size="sm"
            variant="danger"
            class="ml-2"
            v-if="btnAnnullaShow"
            @click="onAnnulla"
          >
            Annulla
          </b-button>
          <b-button
            size="sm"
            variant="success"
            class="ml-2"
            @click="onAggiungiImpegnativa"
            :disabled="isDisabledAggiungiImpegnativa"
          >
            Aggiungi Impegnativa
          </b-button>
        </div>
      </template>
    </b-modal>
     <b-modal
      ref="mdlMedici"
      size="large"
      title="Seleziona un Medico"
      @ok="confermaSelezioneMedico"
      ok-title="Conferma"
      cancel-title="Annulla"
    >
      <b-table
        selectable
        select-mode="single"
        :items="medici"
        :fields="fieldsMedici"
        responsive
        striped
        hover
        @ok="confermaSelezioneMedico"
        @row-selected="onRowSelected"
      >
    
       <template #cell(nome)="row">
            <span>{{ row.item.nome }} {{ row.item.cognome}}</span>
              </template>
    </b-table>

    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
export default {
  props: {
    hideHeaderClose: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    isEdit: {
      type: Boolean,
      require: false,
      default: () => {
        return true;
      },
    },
    isDematerializzata:{
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    codiceFiscalePaziente:{
      type: String,
      require: false,
      default: () => {
        return null;
      },
    },
    noCloseOnEsc: {
      type: Boolean,
      require: false,
      default: () => {
        return true;
      },
    },
    btnAnnullaShow: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
  },
  components: { DatePicker },
  data() {
    return {
      rowSelected:null,
      medici: [
        {
          matricola: "MED-C-NAP-2025-0001",
          nome: "Kevin",
          cognome: "De Bruyne",
          codiceFiscale: "DBRKVN91H28F839X",
          tipologia: "MMG",
          regione: "15",
        },
        {
          matricola: "MED-C-NAP-2025-0002",
          nome: "Scott",
          cognome: "MacTommay",
          codiceFiscale: "MCTSCT95E12F839R",
          tipologia: "MMG",
          regione: "15",
        },
        {
          matricola: "MED-C-NAP-2025-0003",
          nome: "Giovanni",
          cognome: "Di Lorenzo",
          codiceFiscale: "DLRGNN93C25F839T",
          tipologia: "MMG",
          regione: "15",
        },
        {
          matricola: "MED-C-NAP-2025-0004",
          nome: "Lorenzo",
          cognome: "Insigne",
          codiceFiscale: "NSGLRN91A04F839K",
          tipologia: "MMG",
          regione: "15",
        },
        {
          matricola: "MED-C-NAP-2025-0005",
          nome: "Dries",
          cognome: "Mertens",
          codiceFiscale: "MRTDRS87F06F839W",
          tipologia: "MMG",
          regione: "15",
        },
        {
          matricola: "MED-C-NAP-2025-0006",
          nome: "Kalidou",
          cognome: "Koulibaly",
          codiceFiscale: "KLBKLD91F20F839Q",
          tipologia: "MMG",
          regione: "15",
        },
        {
          matricola: "MED-C-MIL-2025-0007",
          nome: "Paolo",
          cognome: "Maldini",
          codiceFiscale: "MLDPOL68A01F205Z",
          tipologia: "MMG",
          regione: "08",
        },
        {
          matricola: "MED-C-ROM-2025-0008",
          nome: "Francesco",
          cognome: "Totti",
          codiceFiscale: "TTTFNC76L27H501V",
          tipologia: "MMG",
          regione: "12",
        },
      ],
      fieldsMedici: [
        {
          field: "matricola",
          label: "Matricola",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "nome",
          label: "Nome",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "codiceFiscale",
          label: "Codice Fiscale",
          type: "string",
          sortable: false,
          filterable: true,
        },
        {
          field: "tipologia",
          label: "Tipologia",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "regione",
          label: "Regione",
          type: "string",
          sortable: true,
          filterable: true,
        },
      ],

      regioniOptions:[

      ],
  rules: {
        presRegione: {
          msg: "Regione Prescrittore non valido",
          rule: (val) =>  val != null,
        },
      },
      localData: {
        tipologiaRicetta: null,
        codiceFiscaleAssistito: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        presNome: null,
        codiceBar1:null,
        codiceBar2:null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        cfMedico:null,
        prestazioni:[]
      },
      presRegioniOptions: [],
      tipologiaRicettaOptions: [
        { text: "CONV", value: "CONVEZIONATO" },
        { text: "SSN", value: "SSN" },
        { text: "ROSSA", value: "ROSSA" },
        { text: "PRIVATA", value: "PRIVATA" },
        { text: "DEMATERIALIZZATA", value: "DEMATERIALIZZATA" },
      ],
      presTipologiaOptions: ["SPEC(SUMAI)", "DIP.ASL", "MMG", "GM", "OSP", "PEDIATRA", "GMTURISTICA", "MOSP-UNIV", "ALTRO"],
      prioritaOptions: ["U", "B", "D", "P"],
      
    };
  },
  mounted() {
    let me = this;
    me.loadRegioni();
    me.setComponentChild();
    if (me.isDematerializzata) {
      me.localData.tipologiaRicetta = "DEMATERIALIZZATA";
    }

    me.localData.codiceFiscaleAssistito = me.codiceFiscalePaziente;
  },
  computed: {
    // isDematerializzataChoise() {
    //   return this.localData.tipologiaRicetta == "DEMATERIALIZZATA"
    //     ? true
    //     : false;
    // },
    isDisabledAggiungiImpegnativa(){
      let me = this;
      if(me.localData.tipologiaRicetta == null){
        return true;
      }else{
        if(me.localData.tipologiaRicetta === "PRIVATA"){
          return false;
        }
      }
      if(me.localData.codiceBar1  == null || me.localData.codiceBar1 === ''){
        return true;
      }
     if(me.localData.codiceBar2  == null || me.localData.codiceBar2 === ''){
        return true;
      }

      return false;
    }
  },
  methods: {
    setComponentChild(){
      let me = this;
      me.edit(me.jsonData);
    },
    edit(jsonData){
      let me = this;
      me.localData = {...me.localData,...jsonData}
    },
    getStateValidationField(fieldName) {
      let me = this;
      const field = me.localData[fieldName];
      if (field === null) {
        return null;
      }
      const rules = me.rules[fieldName];
      if(!rules){
        return true;
      }


      return rules.rule(field);
    },

    getMsg(fieldName) {
      let me = this;
      const fieldValue = me.localData[fieldName];
      const valid = me.getStateValidationField(fieldName);
      const rules = me.rules[fieldName];
      if (fieldValue && !valid || fieldValue == null) {      
        if(rules)
        return rules.msg;
      }
      return null;
    },

    show() {
      this.$refs.mdlImpegnativa.show();
    },
    hide() {
      this.$refs.mdlImpegnativa.hide();
    },
    onRowSelected(row) {
      let me = this;
      me.rowSelected = row;
    },
    onChangeTipologia(tipo) {
      let me = this;
      console.log(tipo);
      if(tipo === "DEMATERIALIZZATA"){
       me.localData = {
        tipologiaRicetta:me.localData.tipologiaRicetta,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        codiceFiscaleAssistito : me.localData.codiceFiscaleAssistito,
        prestazioni:[]
    }
      }
      this.$emit("onChangeTipologiaRicetta", tipo);
    },
    confermaSelezioneMedico() {
      let me = this;
      let json = me.rowSelected[0];
      me.localData.matricola = json.matricola;
      me.localData.presNome = json.nome;
      me.localData.presCognome = json.cognome;
      me.localData.presCodiceFiscale = json.codiceFiscale;
      me.localData.codiceSpecializzazioneMedico =  json.tipologia
      me.localData.presRegione =  json.regione
      me.localData.cfMedico = json.codiceFiscale;
    },

    onAnnulla() {
      let me = this;
      //UtilityMixin.methods.restCallPost("/pathResource",{},me.callBackOnAggiungiImpegnativaSuccess,me.callBackOnAggiungiImpegnativaError)
      me.$emit("onAnnulla", {
        tipologiaRicetta: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        priorita: null,
        cfMedico:null,
        prestazioni:[]
      });
      me.hide();
    },
    onAggiungiImpegnativa() {
      let me = this;
      //POST CALLER
        me.$emit("onAggiungiImpegnativa",me.localData);
       me.hide();
     me.localData = {
        tipologiaRicetta: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        prestazioni:[]
     }
    },
     loadRegioni() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/regioni";
      axios
        .get(link)
        .then((response) => {
          response.data.data.forEach((regione) => {
            me.regioniOptions.push(regione);
          });
        })
    },
  },
};
</script>

<style lang="scss" scoped></style>
